import React from "react";
import PropTypes from "prop-types";
import Icon, { ICONS } from "shared/components/Icon";
import { localeDate } from "shared/helpers/date";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function MeasureChangeLog({ measure }) {
  const [t] = useTranslation();

  return (
    <div className="changeLog">
      <h4 className="changeLog-title">{t("measure.changeLog.title")}</h4>
      {measure?.changes?.map(({ notes, modifiedBy, modifiedAt }, index) => {
        const fullName =
          modifiedBy?.name || modifiedBy?.surname
            ? `${modifiedBy?.name ?? ""} ${modifiedBy?.surname ?? ""}`.trim()
            : "–";

        return (
          <div className="changeLog-item" key={index}>
            <div className="changeLog-icon">
              <Icon name={ICONS.INFO_CIRCLE} spacedLeft />
            </div>

            <div className="changeLog-text">
              <span>{notes || "–"}</span>
              <span>{fullName}</span>
              <span>{modifiedAt ? localeDate(modifiedAt) : "–"}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

MeasureChangeLog.propTypes = {
    measure: PropTypes.object.isRequired
};
